import { Box } from "@gemini/core";
import { Button, CellContent, TextField } from "@gemini/ui";
import { useCallback, useState } from "react";

import {
  setRuntimeApplicationVersionQueryParameter,
  useRuntimeApplication,
} from "../../../federation/runtime";
import { List } from "../List";

import { createTabPanel } from "./createTabPanel";
import { useAutofocusRef } from "./useAutofocusRef";

export const ApplicationTabPanel = createTabPanel({
  label: "Application",
  description: "Current application settings",
  Component({ isActive }) {
    const inputRef = useAutofocusRef(isActive);

    const { id: applicationId, version: applicationVersion = "N/A" } =
      useRuntimeApplication();

    const [applicationVersionInput, setApplicationVersionInput] =
      useState(applicationVersion);

    const onSubmitHandler = useCallback(
      (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setRuntimeApplicationVersionQueryParameter(applicationVersionInput);
      },
      [applicationVersionInput],
    );

    return (
      <>
        <List<{
          key: string;
          title: string;
        }>
          items={[
            {
              key: `${applicationId}`,
              title: "Id",
            },
            {
              key: applicationVersion,
              title: "Version",
            },
          ]}
          renderItem={({ key, title }) => (
            <CellContent
              key={key}
              title={title}
              description={key}
            />
          )}
        />
        <Box
          display="flex"
          flexDirection="row"
          as="form"
          onSubmit={onSubmitHandler}
        >
          <TextField
            ref={inputRef}
            label={{ content: "Application version", isHidden: true }}
            placeholder="Select application version"
            onChange={(value) => setApplicationVersionInput(value)}
            isFullWidth
          />
          <Button
            type="submit"
            variant="primary"
            marginLeft="spacing.12"
          >
            Reload
          </Button>
        </Box>
      </>
    );
  },
});
